module.exports = __webpack_public_path__ + "img/training_3.7583c960.png";